export default{
		data() {
			return {
				right1:'-210px'
			}
		},
		methods:{
			currentType(){
				if(this.right1 == '-210px'){
					this.right1 = '5px'
				}else{
					this.right1 = '-210px'
				}
				console.log(this.right1)
			}
		},
		created(){
			
		}
	}